import React from 'react';
import AppErrorState from './AppErrorState';
import { normalizeAppError } from '../helpers/appRuntime';

const arraysEqual = (left = [], right = []) => {
  if (left.length !== right.length) {
    return false;
  }
  return left.every((value, index) => Object.is(value, right[index]));
};

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    const normalized = normalizeAppError(error, {
      stage: this.props.stage || 'react_boundary',
      path: this.props.path,
      scope: this.props.scope,
      componentStack: info?.componentStack || '',
    });
    console.error('[app-error-boundary]', normalized, info);
  }

  componentDidUpdate(prevProps) {
    if (
      this.state.error &&
      !arraysEqual(prevProps.resetKeys || [], this.props.resetKeys || [])
    ) {
      this.setState({ error: null });
    }
  }

  handleReset = () => {
    this.setState({ error: null });
    if (typeof this.props.onReset === 'function') {
      this.props.onReset();
    }
  };

  render() {
    if (this.state.error) {
      const normalized = normalizeAppError(this.state.error, {
        stage: this.props.stage || 'react_boundary',
        path: this.props.path,
        scope: this.props.scope,
      });

      if (typeof this.props.fallbackRender === 'function') {
        return this.props.fallbackRender({
          error: normalized,
          reset: this.handleReset,
        });
      }

      return (
        <AppErrorState
          title={this.props.title || '页面渲染失败'}
          error={normalized}
          fullscreen={this.props.fullscreen}
          onRetry={this.handleReset}
          onReload={() => window.location.reload()}
          retryLabel='重新渲染'
        />
      );
    }

    return this.props.children;
  }
}

export default AppErrorBoundary;
